import { render, staticRenderFns } from "./map-view.vue?vue&type=template&id=0361b528&scoped=true&"
import script from "./map-view.vue?vue&type=script&lang=js&"
export * from "./map-view.vue?vue&type=script&lang=js&"
import style0 from "./map-view.vue?vue&type=style&index=0&id=0361b528&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361b528",
  null
  
)

export default component.exports